import { createApiClient } from '../services/ApiClient';
import * as types from './ActionTypes';
import { getForms, getTypes, getProjects } from "./index";

export function companies() {
    return (dispatch: any) => {
        const api = createApiClient();
        dispatch({ type: types.LOADING_START, payload: 'companies' });
        try {
            api.getCompanies({
                success: result => {
                    if (result && result.length > 0) {
                        dispatch({type: types.SET_COMPANIES, payload: result});
                    } else {
                        dispatch({type: types.SET_COMPANIES, payload: []});
                    }
                    dispatch({type: types.LOADING_FINISH, payload: 'companies'});
                }
            });
        } catch(e) {
            dispatch({type: types.LOADING_FINISH, payload: 'companies'});
        }
    }
}

export function auth(){
    return (dispatch: any) =>{
        const api = createApiClient();
        dispatch({ type: types.LOADING_START, payload: 'auth' });
        try {
            api.me({
                success: (data) => {
                    if (data && data.id !== 0) {
                        dispatch({type: types.AUTH_USER_SUCCESS, payload: data});
                        if (Number(data.current_company) > 0) {
                            dispatch(setORN(data.current_company));
                            dispatch(getProjects(data.current_company));
                        }
                        dispatch(companies());
                    } else {
                        dispatch({type: types.AUTH_USER_FAILED});
                    }
                    dispatch({type: types.LOADING_FINISH, payload: 'auth'});
                }
            })
        } catch (e) {
            dispatch({type: types.AUTH_USER_FAILED});
            dispatch({type: types.LOADING_FINISH, payload: 'auth'});
        }
    }
}

export function getCompany(orn) {
    return (dispatch: any) => {
        const api = createApiClient();
        dispatch({type: types.LOADING_START, payload: 'companies'});
        if (orn) {
            api.getCompany(orn, {
                success: () => {
                    dispatch(getTypes({
                        success: response => {
                            dispatch({type: types.SET_AVAILABLE_TYPES, payload: response});
                            dispatch(getForms());
                        }
                    }));
                    dispatch(auth());
                    // dispatch({type: types.FETCH_COMPANIES, payload: response});
                },
                anyway: () => {
                    dispatch({type: types.LOADING_FINISH, payload: 'companies'});
                }
            });
        } else {
            dispatch({type: types.LOADING_FINISH, payload: 'companies'});
        }
    }
}

export function setORN(orn: string) {
    return (dispatch: any) => {
        dispatch({type: types.SET_ORN, payload: orn});
        dispatch(getTypes({
            success: response => {
                dispatch({type: types.SET_AVAILABLE_TYPES, payload: response});
                dispatch(getForms());
            }
        }));
        dispatch(getForms());
    }
}
